module.exports = "/static/assets/a54e98269f78b67e2036168fced9b070.svg";